import React, { createContext, useContext, useState } from 'react';

const TextExpansionContext = createContext();

export const useTextExpansion = () => {
  const context = useContext(TextExpansionContext);
  if (!context) {
    throw new Error('useTextExpansion must be used within a TextExpansionProvider');
  }
  return context;
};

export const TextExpansionProvider = ({ children }) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false);

  const handleTextExpansion = (expanded) => {
    // The player container grows to fit its content via CSS (min-height), so no
    // JS height adjustment is needed. We only track expansion state here.
    setIsTextExpanded(expanded);
  };

  const stopVideoPlayer = () => {
    console.log('🛑 Attempting to stop video player...');
    
    // Try to find the VideoJS player instance
    const videoElement = document.querySelector('.video-js');
    if (videoElement && videoElement.player) {
      console.log('✅ Found VideoJS player, stopping...');
      videoElement.player.pause();
      return true;
    }
    
    // Fallback: try to find video element directly
    const videoTag = document.querySelector('video');
    if (videoTag) {
      console.log('✅ Found video element, pausing...');
      videoTag.pause();
      return true;
    }
    
    console.warn('❌ Could not find video player to stop');
    return false;
  };

  const value = {
    isTextExpanded,
    handleTextExpansion,
    stopVideoPlayer,
  };

  return (
    <TextExpansionContext.Provider value={value}>
      {children}
    </TextExpansionContext.Provider>
  );
};
